import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import {
    BaseClientConfig,
    ElectionDefinition,
    getElectionToggles,
    getResolvedTopicPageMeta,
    GetRouteAdTargeting,
    PageType,
    RouteResolution,
    Store,
} from '@news-mono/web-common'
import { createElectorateEmbedPage } from '../embeds/createElectorateEmbedPage'
import { createElectionElectoratePage } from './createElectionElectoratePage'
import { createElectionLandingPage } from './createElectionLandingPage'
import { createElectionPartyTotalsPage } from './createElectionPartyTotalsPage'
import { getTopicPageRouteInfo } from '../../topic/get-topic-page-route-info'

export const createSpecificElectionLandingPage = (
    resolution: RouteResolution,
    electionDefinition: ElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
    config: BaseClientConfig,
): PageType<TheWestSection> | null => {
    const toggles = store.getState().toggles

    const { 'election-landing-page-route': isLandingPageEnabled } =
        getElectionToggles(electionDefinition, toggles)

    if (!isLandingPageEnabled) {
        // Fallback to default topic page layout if available.
        if (
            resolution.type === 'static' &&
            resolution.resolution?.type === 'topic'
        ) {
            return getTopicPageRouteInfo({
                publicationKind: resolution.resolution.publicationKind,
                topic: resolution.resolution.topic,
                config,
                section: resolution.resolution.section as TheWestSection,
                getAdTargeting,
                classification: resolution.resolution.classification,
            })
        }

        return null
    }

    try {
        return createElectionLandingPage({
            getAdTargeting,
            electionDefinition: electionDefinition,
            toggles,
        })
    } catch (error) {
        console.error(
            { error },
            'Error creating election landing page, so defaulting to the topic page route!',
        )
        return null
    }
}

export const createSpecificElectoratesPage = (
    electionDefinition: ElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
): PageType<TheWestSection> | null => {
    const { 'election-electorate-results-route': isElectoratesEnabled } =
        getElectionToggles(electionDefinition, store.getState().toggles)

    if (!isElectoratesEnabled) {
        return null
    }

    return createElectionElectoratePage({
        getAdTargeting,
        electionDefinition: electionDefinition,
    })
}
export const createSpecificPartyTotalsPage = (
    electionDefinition: ElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
): PageType<TheWestSection> | null => {
    // Override meta with that from taxonomy if provided.

    const toggles = store.getState().toggles

    const { 'election-party-totals-route': isPartyTotalsEnabled } =
        getElectionToggles(electionDefinition, toggles)

    if (!isPartyTotalsEnabled) {
        return null
    }

    return createElectionPartyTotalsPage({
        electionDefinition,
        getAdTargeting,
    })
}

export const createSpecificElectionEmbedPage = (
    electionDefinition: ElectionDefinition,
    getAdTargeting: GetRouteAdTargeting,
    store: Store,
) => {
    const enableRoute = isFeatureEnabled(
        toFeatureState(store.getState().toggles),
        'election-widget-preview-page',
    )

    if (!enableRoute) {
        return null
    }

    return createElectorateEmbedPage({
        electionDefinition,
        getAdTargeting,
    })
}
